import { useNavigate, useParams } from 'react-router-dom'
import { useAuditoriaDetalhe } from '../../hooks/useAuditoria'
import styles from '../_shared/CrudPage.module.css'

const ACAO_LABEL: Record<string, string> = {
  create: 'Criação',
  update: 'Atualização',
  delete: 'Remoção',
}

function JsonViewer({ data }: { data: Record<string, unknown> | null }) {
  if (!data || Object.keys(data).length === 0) {
    return <p style={{ color: '#999', fontStyle: 'italic', margin: 0 }}>(vazio)</p>
  }
  return (
    <pre
      style={{
        background: '#FAFAFA',
        padding: '0.75rem',
        borderRadius: 4,
        fontSize: '0.8rem',
        maxHeight: 320,
        overflow: 'auto',
        margin: 0,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
      }}
    >
      {JSON.stringify(data, null, 2)}
    </pre>
  )
}

export default function AuditoriaDetalhePage() {
  const { id = '' } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const detalhe = useAuditoriaDetalhe(id)

  if (detalhe.isLoading) return <div className={styles.loading}>Carregando registro...</div>
  if (detalhe.error || !detalhe.data) {
    return <div className={styles.empty}>Registro não encontrado.</div>
  }
  const r = detalhe.data
  const data = new Date(r.criado_em).toLocaleString('pt-BR')

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div>
          <button
            type="button"
            className={styles.backBtn}
            onClick={() => navigate('/auditoria')}
          >
            ← Voltar
          </button>
          <h1 className={styles.title}>
            {ACAO_LABEL[r.acao] ?? r.acao} • {r.modelo}
          </h1>
          <p style={{ margin: '0.25rem 0', color: '#666' }}>
            {data} • {r.usuario_email ?? 'sistema'}
            {r.ip_address && ` • IP ${r.ip_address}`}
          </p>
        </div>
      </header>

      <section
        style={{
          background: 'white',
          padding: '1.25rem',
          borderRadius: 8,
          marginBottom: '1rem',
          boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
        }}
      >
        <h2 style={{ marginTop: 0, fontSize: '1rem' }}>Identificação</h2>
        <dl style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '0.5rem 1rem' }}>
          <dt style={{ color: '#666' }}>Modelo:</dt>
          <dd style={{ margin: 0 }}>{r.modelo}</dd>
          <dt style={{ color: '#666' }}>Objeto:</dt>
          <dd style={{ margin: 0, fontFamily: 'monospace', fontSize: '0.85rem' }}>
            {r.objeto_id ?? '—'}
          </dd>
          <dt style={{ color: '#666' }}>Ação:</dt>
          <dd style={{ margin: 0 }}>{ACAO_LABEL[r.acao] ?? r.acao}</dd>
          <dt style={{ color: '#666' }}>Quando:</dt>
          <dd style={{ margin: 0 }}>{data}</dd>
        </dl>
      </section>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
        <section
          style={{
            background: 'white',
            padding: '1.25rem',
            borderRadius: 8,
            boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
          }}
        >
          <h2 style={{ marginTop: 0, fontSize: '1rem' }}>Antes</h2>
          <JsonViewer data={r.dados_antes} />
        </section>
        <section
          style={{
            background: 'white',
            padding: '1.25rem',
            borderRadius: 8,
            boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
          }}
        >
          <h2 style={{ marginTop: 0, fontSize: '1rem' }}>Depois</h2>
          <JsonViewer data={r.dados_depois} />
        </section>
      </div>
    </div>
  )
}
